import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Skeleton, Steps } from 'antd';

import { StepMetaProps } from './index';
import { useBeraReportStepsContext } from '../context';
import { CustomSteps, CurrentStep, StepsMenuCol } from './styles';

const Step = Steps.Step;

interface StepsMenuProps {
	currentStep: number;
	stepMenu: StepMetaProps[];
	onStepMenuClick: (step: number) => void;
}

export function StepsMenu({ currentStep, stepMenu, onStepMenuClick }: Readonly<StepsMenuProps>): JSX.Element {
	const { isLoading, clickableResultStep } = useBeraReportStepsContext();

	const isLastStep = currentStep >= stepMenu.length - 1;

	if (isLastStep) return <></>;

	if (isLoading) {
		return (
			<StepsMenuCol sm={4}>
				<Skeleton active />
			</StepsMenuCol>
		);
	}

	return (
		<StepsMenuCol sm={4}>
			<CustomSteps
				current={currentStep}
				result={String(clickableResultStep)}
				active={currentStep}
				direction="vertical"
			>
				{stepMenu.map((step) => {
					const isDisabled = step.key > currentStep;
					const isActive = step.key === currentStep;
					return (
						<Step
							key={step.title}
							disabled={isDisabled}
							onClick={() => {
								if (!isDisabled) {
									onStepMenuClick(step.key);
								}
							}}
							icon={isActive ? <CurrentStep>{I18n.get(step.title)}</CurrentStep> : ''}
						/>
					);
				})}
			</CustomSteps>
		</StepsMenuCol>
	);
}
